import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "home-bottom"
};
const _hoisted_2 = {
  key: 0,
  class: "overlay"
};
const _hoisted_3 = {
  class: "overlay-content"
};
const _hoisted_4 = {
  class: "imagetrans-title"
};
const _hoisted_5 = {
  class: "overlay-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowRight = _resolveComponent("ArrowRight");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ArrowDown = _resolveComponent("ArrowDown");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_image_generateall = _resolveComponent("image_generateall");
  const _directive_click_outside = _resolveDirective("click-outside");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$data.showImageGenerateAll ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "imagetrans-title",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.toggleImageGenerateAll && $options.toggleImageGenerateAll(...args), ["stop"]))
  }, [_createTextVNode(_toDisplayString(_ctx.$t('messages.main_bottom_text')) + " ", 1), _createVNode(_component_el_icon, {
    class: _normalizeClass(['toggle-icon', {
      rotated: $data.showImageGenerateAll
    }])
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  }, 8, ["class"])])) : _createCommentVNode("", true), _createVNode(_Transition, {
    name: "slide-down"
  }, {
    default: _withCtx(() => [$data.showImageGenerateAll ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
      class: "overlay-header",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.toggleImageGenerateAll && $options.toggleImageGenerateAll(...args))
    }, [_createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString(_ctx.$t('messages.main_bottom_text')) + " ", 1), _createVNode(_component_el_icon, {
      class: "toggle-icon"
    }, {
      default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
      _: 1
    })])]), _createVNode(_component_el_divider, {
      style: {
        "margin": "0"
      }
    }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_image_generateall, {
      ref: "imagegenerateall",
      onStartcrop: $options.startcrop,
      onShowDetailDialog: $options.showDetailDialog
    }, null, 8, ["onStartcrop", "onShowDetailDialog"])])])), [[_directive_click_outside, $options.toggleImageGenerateAll]])])) : _createCommentVNode("", true)]),
    _: 1
  })]);
}